import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconToast"><Path d="M19.25 12.2608C20.5021 11.3651 21.25 10.2321 21.25 9C21.25 6.10051 17.1086 3.75 12 3.75C6.89137 3.75 2.75 6.10051 2.75 9C2.75 10.2321 3.49786 11.3651 4.75 12.2608V17.25C4.75 18.9069 6.09315 20.25 7.75 20.25H16.25C17.9069 20.25 19.25 18.9069 19.25 17.25V12.2608Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconToast;
